<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { useValidation } from '@/utils/useValidataion';

const storeSert = useSertStore();

const value = defineModel()

const maxLength = 160;
const count = computed(() => maxLength - value.value.length)

const { validation, isValid, isTouched, textError } = useValidation(value);

const resizeMessage = (e) => {
	const textarea = e.target;
    textarea.style.minHeight = `auto`;
	const textareaHeight = textarea.scrollHeight;
	textarea.style.minHeight = `${textareaHeight}px`;
	textarea.style.transition = `min-height .2s linear`
}

watch(
	() => storeSert.checkedItems.message?.title,
	(newVal) => {
        value.value = newVal ?? "";
        validation('message');
	},
	{ immediate: true }
);

function onInput(e) {
	const val = e.target.value;
	value.value = val;
    storeSert.updateCheckedItem('message', 'title', val);
	
	validation('message');
    resizeMessage(e)
}

onMounted(() => {
})

</script>
<template>
    <label :class="['input']">
        <textarea 
            :class="['input__field --message none-scrollbar']" 
            autocomplete="on"
            :maxlength="maxLength"
            @input="onInput" 
            v-model="value"
            placeholder="Добавьте персональное сообщение"
        >                            
        </textarea>     
        <span class="input__counter"><i>{{ count }}</i>/<i>{{ maxLength }}</i></span>       
        <Transition>
            <span v-if="count === 0" class="input__error">Не более 160 символов</span>
        </Transition>       
    </label>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>